// extracted by mini-css-extract-plugin
module.exports = {"bb-text-with-side-image":"bb-text-with-side-image__OMyKG"};